var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMylisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6658 8H9.33247M4.6658 11.1111H9.33247M10.888 15H3.11024C2.25113 15 1.55469 14.3036 1.55469 13.4444V2.55556C1.55469 1.69645 2.25113 1 3.11024 1H7.45474C7.66102 1 7.85886 1.08194 8.00472 1.22781L12.2158 5.43886C12.3616 5.58472 12.4436 5.78255 12.4436 5.98883V13.4444C12.4436 14.3036 11.7471 15 10.888 15Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylisting);
export default __webpack_public_path__ + "static/media/mylisting.88d3c84857c43b0a378285d9d7c4e6a1.svg";
export { ForwardRef as ReactComponent };